import { createContext, useState } from "react";

export const AccountRegisterHistoryContext = createContext({});

export const Provider = (props) => {
    const { children } = props;

    const [accountRegisterHistories, setAccountRegisterHistories] = useState([]);
    const [accountRegisterHistoryDetails, setAccountRegisterHistoryDetails] = useState([]);
    const [accountRegisterHistoryDialog, setAccountRegisterHistoryDialog] = useState(false);

    // Make the context object:
    const accountRegisterHistoryContext = {
        accountRegisterHistories,
        setAccountRegisterHistories,
        accountRegisterHistoryDialog,
        setAccountRegisterHistoryDialog,
        accountRegisterHistoryDetails,
        setAccountRegisterHistoryDetails,
    };

    // pass the value in provider and return
    return <AccountRegisterHistoryContext.Provider value={accountRegisterHistoryContext}>{children}</AccountRegisterHistoryContext.Provider>;
};

export const { Consumer } = AccountRegisterHistoryContext;
